import { css, html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';

export class InputWrapperComponent extends LitElement {
  @property({ attribute: 'max-length', reflect: true, type: Number }) maxLength?: number;

  @state() private currentLength = 0;

  override render() {
    return html`
      <header>
        <slot name="label"></slot>
      </header>
      <div class="input-wrapper">
        <slot @input="${this.handleInput.bind(this)}"></slot>
      </div>

      ${when(this.maxLength, (maxLength) => html`<p>${this.currentLength}/${maxLength}</p>`)}
    `;
  }

  static override styles = css`
    :host {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      anchor-scope: all;
    }

    .input-wrapper {
      anchor-name: --input;
      display: flex;
    }

    ::slotted(input) {
      width: 100%;
    }

    p {
      margin: 0;
      position-anchor: --input;
      position: absolute;
      bottom: calc(anchor(100%) + 0.75rem);
      right: calc(anchor(100%) + 1rem);
    }

    @supports not (anchor-name: --test) {
      p {
        position: absolute;
        bottom: 0.5rem;
        right: 1rem;
        transform: translateY(-50%);
      }

      :host {
        position: relative;
      }
    }
  `;

  private handleInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.currentLength = inputElement.value.length;
  }
}

export function defineInputWrapperComponent() {
  if (!customElements.get('y-input-wrapper')) {
    customElements.define('y-input-wrapper', InputWrapperComponent);
  }
}
